import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-monitor/run-log";

// tbl_rem_run_log (one row per rule evaluation, written by the engine).
const apiReminderRunLog = {
  getAll:   (payload) => axiosClient.post(`${BASE}/get-all`, payload),
  // One run (a test run with its preview: test_result).
  getById:  (id)      => axiosClient.get(`${BASE}/get-by-id/${id}`),
  // { rule_fid?, fromDate?, toDate? } -> { by_status, by_rule }
  getStats: (payload) => axiosClient.post(`${BASE}/get-stats`, payload),
};

export default apiReminderRunLog;
